import { useDetailsPanelsActions } from "PFApp/booking/components/details_panel/index.ts";
import { AvailabilityContent } from "PFApp/profiles/common/availability";
import { ProfileBookingsProvider } from "PFApp/profiles/common/profile_bookings_provider";
import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { useProfilePreviewData } from "PFApp/use_profile_preview";
import { Button } from "PFComponents/button";
import { isProfileActive } from "PFCore/helpers/profile";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useTranslation } from "react-i18next";

import { BookingFormMode } from "../../../booking/components/booking_form/booking_form.types";
import useIsAvailabilityPermitted from "../../../use_is_availability_permitted";
import ViewInBookingModuleButton from "../../view_in_booking_module_button/view_in_booking_module_button";
import css from "./profile_preview_avalability.module.scss";
import { ProfilePreviewHeader } from "./profile_preview_header";

const ProfilePreviewAvailability = () => {
  const { t } = useTranslation("core");

  const {
    data: { profile, id, ready, showBookingButtons }
  } = useProfilePreviewData();

  const {
    data: { templates, availability }
  } = useMyAccountInfo();

  const { openBookingFormSidePanel } = useDetailsPanelsActions();

  const isActive = isProfileActive(profile);
  const isAvailabilityPermitted = useIsAvailabilityPermitted(profile);
  const { canProfileCreateBooking } = useBookingModulePermissions();

  const canSeeBookingModule = canProfileCreateBooking(profile?.id);

  const canAddBooking = showBookingButtons && canSeeBookingModule && isActive;

  if (!ready || !profile || !profile.availability || !isAvailabilityPermitted) {
    return null;
  }

  if (profile.permissionsGroup === undefined) {
    return null; // probably not needed because "ready" is taking care but left just in case
  }

  const actions = canAddBooking && (
    <Button
      kind="secondary"
      onClick={() => {
        if (id) {
          openBookingFormSidePanel(
            {
              profileId: id
            },
            { mode: BookingFormMode.Create }
          );
        }
      }}
      key="booking"
    >
      +{t("booking")}
    </Button>
  );

  return (
    <ProfileBookingsProvider
      templates={templates}
      profile={profile}
      bookingCategories={availability.bookingCategories}
    >
      <div data-qa-id="ProfilePreviewAvailability">
        <ProfilePreviewHeader headerClassName={css.header} actions={actions}>
          <span>{t("profilePreview.availability")}</span>
          {canSeeBookingModule && <ViewInBookingModuleButton workforceMemberId={profile?.id} />}
        </ProfilePreviewHeader>
        <AvailabilityContent activeViews={["calendar"]} profile={profile} readOnly={true} />
      </div>
    </ProfileBookingsProvider>
  );
};

export default ProfilePreviewAvailability;
